import React from 'react';

/**
 * ErrorBoundary component - Catches errors in child components
 * Prevents entire page from crashing when a component fails
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so next render shows fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <div style={{
          padding: '2rem',
          margin: '1rem',
          borderRadius: '8px',
          backgroundColor: '#fff3f3',
          border: '2px solid #ff6b6b',
          color: '#c92a2a'
        }}>
          <h3 style={{ margin: '0 0 0.5rem 0' }}>Something went wrong</h3>
          <p style={{ margin: '0', fontSize: '0.9rem' }}>
            This section encountered an error. Please refresh the page or contact support if the problem persists.
          </p>
          {this.state.error && (
            <details style={{ marginTop: '1rem', fontSize: '0.85rem' }}>
              <summary style={{ cursor: 'pointer' }}>Error details</summary>
              <pre style={{ 
                marginTop: '0.5rem', 
                padding: '0.5rem', 
                backgroundColor: '#ffe0e0', 
                borderRadius: '4px',
                overflow: 'auto' 
              }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
